/** Formats elapsed time as H:MM:ss (hours unpadded, minutes and seconds zero-padded). */
export const formatElapsedSeconds = (totalSeconds) => {
    const s = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = s % 60;
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
export const formatDurationMs = (ms) => formatElapsedSeconds(Math.floor(ms / 1000));
